<template>
    <div>
        <b-modal id="bookmaker-edit" title="Update bookmaker" :hide-footer="hideFooter">
            <form>
                <div class="form-group">
                    <label for="#bkmName">Bookmaker Name:</label>
                    <input class="form-control" type="text" id="bkmName" placeholder="Ex: Bet365" required="required" v-model="bookmaker.name">
                </div>
                <div class="form-group">
                    <label for="#bkmCode">Bookmaker Code:</label>
                    <input class="form-control" type="text" id="bkmCode" placeholder="Ex: 1" required v-model="bookmaker.code">
                </div>
                <div class="form-group">
                    <label for="#bkmDescription">Bookmaker Description:</label>
                    <textarea class="form-control" id="bkmDescription" v-model="bookmaker.description"></textarea>
                </div>
                <div class="form-group">
                    <label for="#bkmDescription">Restricted Countries:</label>
                    <textarea class="form-control" id="bkmRestrictedCountries" v-model="bookmaker.restricted_countries"></textarea>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="updateBookmaker">Update</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      hideFooter: true,
      bookmaker: '',
      bookmakerID: ''
    }
  },
  methods: {
    updateBookmaker () {
      if (this.bookmaker.description &&
              this.bookmaker.code &&
              this.bookmaker.name) {
        this.$http.patch(`${this.$api_url}/bookmaker/` + this.bookmakerID, { name: this.bookmaker.name, code: this.bookmaker.code, description: this.bookmaker.description, restricted_countries: this.bookmaker.restricted_countries }).then((success, error) => {
          if (success) {
            Bus.$emit('bookmakerUpdated', success.data)
            this.$bvModal.hide('bookmaker-edit')
          }
          if (error) {
            this.$bvModal.hide('bookmker-add')
            alert('Something wrong just happened!')
          }
        })
      }
    },
    loadBookmakerData () {
      this.$http.get(`${this.$api_url}/bookmaker/` + this.bookmakerID).then((bookmaker) => {
        if (bookmaker) {
          this.bookmaker = bookmaker.data
        }
      })
    }
  },
  mounted () {
    Bus.$on('editBookmaker', ({ _id }) => {
      this.bookmakerID = _id
      this.loadBookmakerData()
    })
  },
  beforeDestroy () {
    Bus.$off('modalBookmakerEditOpened')
  }
}
</script>
<style scoped>

</style>
